import { Modal } from 'antd';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import Footer from '.././common/Footer';
import './headerModal.scss';

type Props = {
  visibleModal: boolean;
  setVisibleModal: (visible: boolean) => void;
  lng: string;
};

const HeaderModal: FC<Props> = ({ visibleModal, setVisibleModal, lng }) => {
  const { t } = useTranslation();

  const closeHeaderModal = (): void => {
    setVisibleModal(false);
  };

  return (
    <div>
      <Modal
        open={visibleModal}
        footer={null}
        onCancel={() => setVisibleModal(false)}
        className={'modal-conatiner'}
        style={{ width: window.innerWidth }}
        destroyOnClose
      >
        <div className="header-content language-container link border-bottom">
          <div className={`lng-container`}>
            <div className="header-content-tab link">
              <Link className="link" to={`/${lng}/search`} onClick={closeHeaderModal}>
                {t('search')}
              </Link>
            </div>
            <div className="header-content-tab link">
              <Link className="link" to={`/${lng}/rates`} onClick={closeHeaderModal}>
                {t('rates')}
              </Link>
            </div>
            <div className="header-content-tab link">
              <Link className="link" to={`/${lng}/blog`} onClick={closeHeaderModal}>
                {t('blog')}
              </Link>
            </div>
            <div className="header-content-tab link">
              <Link className="link" to={`/${lng}/referrer`} onClick={closeHeaderModal}>
                {t('becomePartner')}
              </Link>
            </div>
            <div className="header-content-tab link">
              <Link className="link" to={`/${lng}/about`} onClick={closeHeaderModal}>
                {t('about')}
              </Link>
            </div>
            <div className="header-content-tab link">
              <Link className="link" to={`/${lng}/privacy`} onClick={closeHeaderModal}>
                {t('privacyPolicy')}
              </Link>
            </div>
          </div>
        </div>
        <Footer newClass="header-modal-footer" handleClick={() => setVisibleModal(false)} isheaderModal />
      </Modal>
    </div>
  );
};

export default HeaderModal;
